<template>
    <div class="main">
        <page-header :heading="pageHeader.title" />

        <div class="row">
            <div class="col">
                <div v-if="!itemsSelected">
                    <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <span>View <i class="arrow down"></i></span>
                        </template>
                        <b-dropdown-item disabled href="#" @click="() => view = 1">Card</b-dropdown-item>
                        <b-dropdown-item disabled href="#" @click="() => view = 2">Table</b-dropdown-item>
                    </b-dropdown>

                    <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <span>Order <i class="arrow down"></i></span>
                        </template>
                        <b-dropdown-item href="#" @click="() => order = 1">Submitted Date</b-dropdown-item>
                        <b-dropdown-item href="#" @click="() => order = 2">Document Approved Date</b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
            <div class="col col-auto">
                <button type="button" :disabled="true" class="btn btn-outline-primary mr-1" @click="showFilters()"><i class="fas fa-filter"></i> Filter</button>
                <button type="button" :disabled="true" class="btn btn-outline-primary mr-1" @click="showSearch()"><i class="fas fa-search"></i> Search</button>
                <button type="button" :disabled="isExportDisabled" class="btn btn-outline-primary" @click="showExport()"><i class="fas fa-file-download"></i> Batch / Export</button>
            </div>
        </div><div class="row">
            <div v-if="loading" class="text-center">
                <b-spinner label="Spinning"></b-spinner>
            </div>
            <div v-else>
                <b-card :title="file.originalFilename"
                        style="max-width: 50rem;"
                        class="mb-2">
                    <b-card-text>
                        <b>Uploaded:</b> {{file.dateCreated | datetime}}
                    </b-card-text>
                </b-card>
                <!--<span>{{file.originalFilename}}</span>-->
                <table class="table table-hover mt-5">
                    <thead>
                        <tr>
                            <th>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox"
                                           class="custom-control-input"
                                           :id="'check_selectAll'"
                                           :key="'check_selectAll'"
                                           :ref="'check_selectAll'"
                                           :name="'check_selectAll'"
                                           v-model="selectAll"
                                           @change="handleSelectAll()">
                                    <label class="custom-control-label" :for="'check_selectAll'"></label>
                                </div>
                            </th>
                            <th>ClaimReference</th>
                            <th>Underwriter</th>
                            <th>AuthorisationId</th>
                            <th>JobNumber</th>
                            <th>InvoiceNumber</th>
                            <th>Device</th>
                            <th>RepairType</th>
                            <th>Gross</th>
                            <th>PipelineResult</th>
                            <th>Batch</th>
                            <th>Status</th>
                            <th>...</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(itm,idx) in items">
                            <tr :class="{'table-danger': !itm.authorisationId}">
                                <td>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox"
                                               class="custom-control-input"
                                               :id="'check_' + idx"
                                               :key="'check_' + idx"
                                               :ref="'check_' + idx"
                                               :value="idx"
                                               :name="'check_' + idx"
                                               v-model="itemsSelected">
                                        <label class="custom-control-label" :for="'check_' + idx"></label>
                                    </div>
                                </td>
                                <td><a href="#">{{itm.claimReference}}</a></td>
                                <td>{{itm.underwriter}}</td>
                                <td>{{itm.authorisationId}}</td>
                                <td>{{itm.jobNumber}}</td>
                                <td></td>
                                <td>{{itm.deviceModel}}</td>
                                <td>{{itm.supplierRepairType}}</td>
                                <td>{{itm.grossCurrencyUK}}</td>
                                <td><span :class="resultKlass({ status: itm.pipelineStatus })">{{itm.pipelineStatus}}</span></td>
                                <td>{{itm.batchNumber}}</td>
                                <td><span :class="statusKlass(itm)">{{getStatusTextDefault(itm)}}</span></td>
                                <td>
                                    <div>
                                        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'" class="right-edge-menu">
                                            <template v-slot:button-content>
                                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                                <span class="sr-only">Actions menu</span>
                                            </template>
                                            <b-dropdown-item v-for="(action, idx) in actions"
                                                             href="javascript:void(0)"
                                                             :disabled="action.disabled ? action.disabled(itm) : false"
                                                             @click="handleActionClick(action, { index: rowIndex, ...itm})">
                                                <i v-if="action.iconClass" :class="action.iconClass"></i> {{action.text}}
                                            </b-dropdown-item>

                                            <!-- Custom nested submenu -->
                                            <b-dropdown-item-button class="submenu" :disabled="!isBatchable(itm)">
                                                Add to batch ▸
                                                <div class="submenu-content">
                                                    <b-dropdown-item v-for="(num,bidx) in batchesForThisFile" @click="handleAddToBatchClick(num,itm)">{{num}}</b-dropdown-item>
                                                </div>

                                            </b-dropdown-item-button>

                                            <b-dropdown-divider></b-dropdown-divider>
                                            <b-dropdown-item href="#" @click="rowClick(itm,idx)">View Rules</b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="expandedRow === idx">
                                <td colspan="9">
                                    <table calss="table">
                                        <thead>
                                        <th>Rule</th>
                                        <th>Message</th>
                                        <th>RuleResult</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(subitm, subidx) in itm.rules">
                                                <td>{{subitm.ruleName}}</td>
                                                <td>{{subitm.message}}</td>
                                                <td><span :class="resultKlass(subitm)">{{subitm.status}}</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
                <button type="button" class="btn btn-outline-primary mr-1" @click="goBack"><i class="fas fa-backward"></i> Back</button>
            </div>
            
            <slidy-thing id="export" ref="export" width="617px" openOn="right" v-on:panel-close="exportPanelClose">
                <div class="container" :style="slidyThingContainerStyle2">
                    <b-card no-body>
                        <b-tabs card v-model="exportTabIdx">
                            <b-tab title="New" active>
                                <p>You have selected {{this.itemsSelected.length}} items to batch.</p>
                                <p v-if="!allSelectedItemsApproved">Not all items you have selected are Approved.  You can only batch Approved items!</p>
                                <p v-if="!allSelectedItemsNotBatched">At least one of the items you have selected is already Batched.  You can not add an item to more than one batch!</p>

                                <div class="form-group">
                                    <label for="export-filename">Batch number / Filename:</label>
                                    <input type="text" class="form-control" id="export-filename" v-model="batchNumber" @keyup="sanitiseBatchNumber">
                                </div>
                                <button type="button" :disabled="!allSelectedItemsApproved" class="btn btn-outline-primary mt-2" @click="handleBatchItemsClick">Batch / Export</button>
                            </b-tab>
                            <b-tab title="Previous">

                            </b-tab>
                        </b-tabs>
                    </b-card>
                </div>
            </slidy-thing>
        </div>
    </div>
</template>
<script>
    import PageHeader from '@/components/PageHeader.vue'
    import { mapActions, mapGetters } from "vuex";
    import SlidyThing from "@/components/SlidyThing.vue";
    export default {
        components: {
            PageHeader,
            SlidyThing
        },
        data() {
            return {
                pageHeader: {
                    title: 'Reconcile the work items',
                },
                fileId: null,
                expandedRow: null,
                selectAll: false,
                itemsSelected: [],
                actions: [
                    {
                        id: 1001,
                        text: 'Approve',
                        disabled: itm => itm.batchNumber != null || itm.status == 'Approved',
                        iconClass: null
                    },
                    {
                        id: 1002,
                        text: 'Reject',
                        disabled: itm => itm.batchNumber != null || itm.status == 'Rejected',
                        iconClass: null
                    }],
                batchNumber: null,
                exportTabIdx: null,
                loading: false
            }
        },
        computed: {
            ...mapGetters({
                fileProgress: 'suplPayments/getWorkItemFileReconciliation'
            }),
            file() {
                console.log('-this.fileProgress: ', this.fileProgress)
                if (this.fileProgress) {
                    return {
                        id: this.fileProgress.id,
                        originalFilename: this.fileProgress.originalFilename,
                        dateCreated: this.fileProgress.dateCreated
                    }
                } else {
                    return {}
                }
            },
            items() {
                if (this.fileProgress) {
                    return this.fileProgress.items
                } else {
                    return []
                }
            },
            isExportDisabled() {
                return this.itemsSelected.length == 0
            },
            slidyThingContainerStyle2() {
                return {
                    "overflow-y": "auto",
                    "max-height": "100%",
                    "max-width": '600px',
                    "min-width": '600px'
                }
            },
            allSelectedItemsApproved() {
                return Array.isArray(this.itemsSelected) &&
                    this.itemsSelected.length > 0 &&
                    this.itemsSelected.every(idx => {
                        const itm = this.items[idx]
                        return itm && itm.status === 'Approved'
                    });
            },
            allSelectedItemsNotBatched() {
                return Array.isArray(this.itemsSelected) &&
                    this.itemsSelected.length > 0 &&
                    !this.itemsSelected.some(idx => {
                        const itm = this.items[idx]
                        return itm && itm.status === 'Batched'
                    });
            },
            batchesForThisFile() {
                if (this.fileProgress) {

                    return [...new Set(
                        this.fileProgress.items
                            .filter(i => i.batchNumber != null)
                            .map(i => i.batchNumber)
                    )];
                } else {
                    return []
                }
            }
        },
        methods: {
            ...mapActions({
                loadWorkItemFileReconciliation: "suplPayments/getWorkItemFilesReconciliation",
                setWorkItemRowStatus: "suplPayments/setWorkItemRowStatus",
                checkBatchNumber: "suplPayments/checkBatchNumber",
                batchItems: "suplPayments/batchItems",
                addToBatch: "suplPayments/addToBatch"
            }),
            rowClick(itm, idx) {
                if (this.exandedRow == idx)
                    this.exandedRow = null
                else
                    this.expandedRow = idx
            },
            async handleActionClick(action, item) {
                console.log('-action: ', action)
                console.log('-item: ', item)
                const result = await this.setWorkItemRowStatus({ statusId: action.id, rowId: item.supplierWorkItemImportRowId, reasonDetails: null })
                console.log('-result: ', result)
            },
            getStatusTextDefault(itm) {
                if (itm) {

                    if (itm.batchNumber) {
                        return 'Batched'
                    } else if (itm.status) {
                        return itm.status
                    } else {
                        return 'Awaiting action'
                    }

                    console.log('-itm: ', itm)
                    //if (itm.status) {
                    //    return itm.status
                    //} else if (itm.batchNumber) {
                    //    return 'Batched'
                    //} else {
                    //    return 'Awaiting action'
                    //}
                }
            },
            isBatchable(itm) {
                if (itm.batchNumber == null && itm.status == 'Approved') {
                    return true
                }
                return false
            },
            statusKlass(itm) {
                if (itm) {

                    if (itm.batchNumber) {
                        return 'badge bg-secondary text-white'
                    } else if (itm.status == 'Approved' || itm.status == 'Paid') {
                        return 'badge bg-success text-white'
                    }
                    else if (itm.status == 'Rejected') {
                        return 'badge bg-danger text-white'
                    } else {
                        return 'badge bg-warning text-white'
                    }

                    //if (itm.status == 'Approved' || itm.status == 'Paid') {
                    //    return 'badge bg-success text-white'
                    //}
                    //else if (itm.status == 'Rejected') {
                    //    return 'badge bg-danger text-white'
                    //}
                    //else if (itm.batchNumber) {
                    //    return 'badge bg-secondary text-white'
                    //} else {
                    //    return 'badge bg-warning text-white'
                    //}
                } 
            },
            resultKlass(itm) {
                if (itm) {
                    if (itm.status == 'PASSED') {
                        return 'badge bg-success text-white'
                    }
                    else if (itm.status == 'FAILED') {
                        return 'badge bg-danger text-white'
                    } else {
                        return 'badge bg-warning text-white'
                    }
                }
            },
            showExport() {
                //console.log(`Exporting ${this.itemsSelected.length} rows`)
                //this.itemsSelected.forEach( idx => {
                //    console.log('Item: ', this.fileProgress[idx])
                //})
                //const allApproved =
                //    Array.isArray(this.itemsSelected) &&
                //    this.itemsSelected.length > 0 &&
                //    this.itemsSelected.every(idx => {
                //        const itm = this.fileProgress[idx]
                //        return itm && itm.status === 'Approved'
                //    });

                //console.log('AllApproved: ', allApproved)
                //if (allApproved)
                //    console.log('All approved!')
                //else
                //    console.log('Not all items have been approved!')

                //console.log('Batch: ', this.createBatchNumber())

                this.batchNumber = this.createBatchNumber()
                if (this.$refs["export"]) {
                    this.$refs["export"].showPanel();
                    this.exportTabIdx = 0
                }
            },
            createBatchNumber(prefix = 'batch') {

                const now = new Date();

                const timestamp = now.getFullYear().toString() +
                    String(now.getMonth() + 1).padStart(2, '0') +
                    String(now.getDate()).padStart(2, '0') + '_' +
                    String(now.getHours()).padStart(2, '0') +
                    String(now.getMinutes()).padStart(2, '0') +
                    String(now.getSeconds()).padStart(2, '0');

                const randomSuffix = Math.floor(Math.random() * 10000);

                // Combine into filename
                return `${prefix}_${timestamp}_${randomSuffix}`;

            },
            sanitiseBatchNumber() {
                if (typeof this.batchNumber === 'string' || this.batchNumber instanceof String)
                    this.batchNumber = (this.batchNumber.replace(/[ &\/\\#,+()$~%.'":*?<>{}[];]/g, ''))
                else
                    this.exportFilter.filename = null
            },
            exportPanelClose(ev) {
                this.batchNumber = null
                this.exportTabIdx = 1
            },
            handleSelectAll() {
                console.log('-selectAll: ', this.selectAll)
                if (this.selectAll) {
                    this.itemsSelected = []
                    let total = this.fileProgress.length
                    for (let i = 0; i < total; i++) {
                        this.itemsSelected.push(i)
                    }
                } else {
                    this.itemsSelected = []
                }
            },
            async handleBatchItemsClick() {
                // check batch number
                const result = await this.checkBatchNumber({ batchNumber: this.batchNumber })
                /*console.log('-result: ', result)*/

                const batchItemIds =
                    Array.isArray(this.itemsSelected) &&
                    this.itemsSelected.length > 0 &&
                    this.itemsSelected.map(idx => {
                        const itm = this.items[idx]
                        return itm.supplierWorkItemImportRowId
                    });

                const batchResult = await this.batchItems({
                    batchNumber: this.batchNumber,
                    workItemFileId: this.fileId,
                    workItemRowIds: batchItemIds
                })
                /*console.log('-batchResult: ', batchResult)*/
                if (this.$refs["export"]) {
                    this.$refs["export"].hidePanel()
                    this.exportTabIdx = 0
                    this.itemsSelected = []
                }
            },
           async handleAddToBatchClick(batchNumber, itm) {
                console.log('-itm: ', itm)
                console.log('-payload: ', {
                    batchNumber: batchNumber,
                    workItemFileId: this.fileId,
                    workItemRowIds: [itm.supplierWorkItemImportRowId]
                })

                const addToBatchResult = await this.addToBatch({
                    batchNumber: batchNumber,
                    workItemFileId: this.fileId,
                    workItemRowIds: [itm.supplierWorkItemImportRowId]
                })

               console.log('-addToBatchResult: ', addToBatchResult)
            },
            goBack() {
                if (window.history.length > 1) {
                    this.$router.go(-1); // or this.$router.back();
                } else {
                    // If no history, navigate to a default route
                    this.$router.push("/finance/supplierpayments/");
                }
            }
        },
        mounted() {
            this.fileId = this.$route.params.id
            this.loadWorkItemFileReconciliation(this.fileId).finally(() => {
                this.loading = false
            })
        }
    }
</script>
<style scoped>



    /* Base submenu */
    .submenu {
        position: relative;
    }

    /* Hidden by default */
    .submenu-content {
        display: none;
        position: absolute;
        left: 100%;
        top: 0;
        min-width: 180px;
        background: white;
        border: 1px solid #ccc;
        z-index: 2000;
        white-space: nowrap;
    }

    /* ✅ Show submenu on hover when NOT disabled */
    .submenu:hover button:not([disabled]) .submenu-content {
        display: block;
    }

    /* ✅ Disabled button styling */
    .submenu button[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    /* ✅ Flip submenu for right-aligned menus */
    .right-edge-menu .submenu .submenu-content {
        right: 100%;
        left: auto;
    }
</style>